<kendo-tabstrip [tabscroll]="false" class="fill flex-fill" (tabSelect)="tabAction($event)" [keepTabContent]="true" [animate]="true" #tabstrip>
  <kendo-tabstrip-tab [selected]="true" class="flex-column">
    <ng-template kendoTabTitle>
      Home
    </ng-template>
    <ng-template kendoTabContent>
      <div class="flex-column" style="width: 100%; height:100%">
        <!--using mat-toolbar here for now, until we're able to update the styles of app-header across the board-->
        <mat-toolbar class="mat-toolbar-action-header fixed-height-30px">
          <span style="flex: 1 1 1e-09px; box-sizing: border-box;"></span>
          <div>
            <button type="button" [disabled]="selectedProjects.length == 0" kendoButton themeColor="primary" [svgIcon]="icons.folderOpen" (click)="openProjects($event)"> Open</button>
            @if (showCreateNewButton) {
              <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.plusCircle" (click)="createNewProjectTab($event)"> Create</button>
            }
            <pxd-grid-menu [columns]="columns" [grid]="projectListView?.grid()" [columnSettingsKey]="columnSettingsKey"></pxd-grid-menu>
          </div>
        </mat-toolbar>

        <app-project-view-list #projectListView class="flex-column" style="height:calc(100% - 30px)" [columns]="columns" [tabItems]="tabItems" [tabstrip]="tabstrip" (onSelectedProjectsChanged)="onSelectedProjectsChanged($event)" (parentLoader)="getLoader($event)">
        </app-project-view-list>
      </div>
    </ng-template>
  </kendo-tabstrip-tab>

  <!-- || Dynamic tabs begin ||      -->
  @for (tabItem of tabItems; track tabItem; let i = $index) {
    <kendo-tabstrip-tab class="flex-column">
      <ng-template kendoTabTitle>
        <div class="project-tab" #tabstripTabItem>
          {{ tabItem.Name }}
          <div class="project-tab--close" (click)="closeTab(i,tabItem)">
            <i class="material-icons">clear</i>
          </div>
        </div>
        <kendo-contextmenu [target]="tabstripTabItem" (select)="selectTabMenuContextItem($event)">
          <kendo-menu-item text="Close All">
          </kendo-menu-item>
          <kendo-menu-item text="Close Others" [data]="{tabItem: tabItem, tabIndex: i}">
          </kendo-menu-item>
        </kendo-contextmenu>
      </ng-template>
      <ng-template kendoTabContent>
        @if (tabIndex[i +1]) {
          <app-project-base-scenario
            class="flex-fill flex-column flex-100"
            (closeNewProjectTab)="closeNewTab($event)"
            [projectData]="tabItem">
          </app-project-base-scenario>
        }
      </ng-template>
    </kendo-tabstrip-tab>
  }
  <!--  ||  Dynamic tabs end  ||     -->

</kendo-tabstrip>